<template>
  <v-container>
    <v-row justify="center">
      <v-col :cols="12" :sm="9" :md="10" :lg="11" :xl="11" class="px-0 py-0">
        <v-card flat>
          <v-container class="py-0">
            <v-row>
              <v-col :cols="7" class="pb-0 pl-4">
                <span
                  style="color:#444444; font-family: sfDisplaySemFont;font-size:20px;font-weight:600;"
                  >Address Detail</span
                >
              </v-col>
              <v-col :cols="11" class="pt-1 pb-3 pl-4">
                <p style="font-size:14px;" class="mb-0 grey--text">
                  {{ address }}
                </p>
              </v-col>
            </v-row>
          </v-container>
          <List-View
            :attributes="addressAttr"
            :limit="addressAttr.length"
            :key="address"
            class="pt-0"
          />
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col :cols="12" :sm="10" :md="10" :lg="11" :xl="11" class="py-0 px-0">
        <v-card flat scrollable>
          <v-container class="pt-0">
            <v-card flat active-class="">
              <v-row>
                <v-col cols="auto" class="pt-0">
                  <span
                    style="font-family: sfDisplaySemFont;font-size:20px;font-weight:600;"
                    >Latest Transactions</span
                  >
                </v-col>
                <v-spacer></v-spacer>
                <!-- <v-col cols="auto">
                <v-menu offset-y min-width="100">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      color="primary"
                      text
                      height="25"
                      style="min-width:0px !important; padding:0px !important;"
                      v-on="on"
                    >
                      <span class="original-text-button text-capitalize">
                        {{
                        type
                        }}
                      </span>
                      <v-icon>mdi-chevron-down</v-icon>
                    </v-btn>
                  </template>
                  <v-list dense class="color:primary">
                    <v-list-item
                      v-for="(item, index) in txTypes"
                      :key="index"
                      @click="searchByType(item)"
                    >
                      <v-list-item-title>
                        <span :class="menuItemFontColor(item)">{{ item }}</span>
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
                </v-col>-->
              </v-row>
            </v-card>
            <v-card flat>
              <expand-table
                :prop-limit="limit"
                :apiUrl="apiUrl"
                :params="txParams"
                :links="links"
                :attributes="attributes"
                :order="order"
                :subtile="subtile"
                :key="address"
                @listenChild="listenExpandTable"
                ref="txTable"
                :infiniteLoading="true"
                class="pt-0"
              />
            </v-card>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import ListView from "../material/ListView.vue";
import ExpandTable from "../material/ExpandTable.vue";
import { mapState, mapMutations } from "vuex";
import Base58 from "base-58";
import Blake2b from "blake2b";
import Sha3 from "js-sha3";
export default {
  components: {
    ListView,
    ExpandTable
  },
  data() {
    return {
      addressLength: 35,
      address: "",
      addressInfo: {},
      txParams: {},
      type: "all",
      txTypes: ["all", "init", "supercede", "send", "issue", "destroy"],
      attributes: [
        { text: "ID", value: "transactionId" },
        { text: "Amount", value: "amountStr" }
      ],
      addressAttr: [
        { text: "Balance", value: "balance", type: "transform_unity" },
        {
          text: "First Active Time",
          value: "createdAt",
          type: "timestamp"
        },
        {
          text: "Transaction Count",
          value: "transactionCount",
          type: "thousands"
        },
        { text: "Active Status", value: "updatedAt", type: "time_ago" }
      ],
      subtile: {
        transactionId: {
          type: "prop",
          property: "timestamp",
          propType: "timestamp",
          text: "ID"
        },
        timestamp: { type: "time_ago", text: "Timestamp" },
        amountStr: {
          type: "income_outcome",
          text: "Amount",
          mobileHidden: true
        },
        signer: { type: "address", text: "Sender" },
        // functionIndexType: { type: "text", text: "Type" },
        recipient: { type: "address", text: "Recipient" },
        status: { type: "status", text: "Status" },
        height: {
          type: "thousands",
          text: "Block Height",
          computerHidden: true
        }
      },
      order: ["signer", "recipient", "status", "height"],
      limit: 10,
      apiUrl: `${this.$config.apiEndPoint}/token/transactions`,
      links: {
        transactionId: "/transaction/:transactionId",
        signer: "/address/:address",
        recipient: "/address/:address"
      },
      network_byte: null
    };
  },
  computed: {
    ...mapState(["queryAnswer", "tokenId", "tokenInfo"])
  },
  async created() {
    this.network_byte =
      this.$config.net === "testnet" ? "T".charCodeAt(0) : "M".charCodeAt(0);
    this.address = this.$route.params.address;
    this.txParams = { tokenId: this.tokenId, address: this.address };
    this.getAddressInfo();
  },
  methods: {
    ...mapMutations([
      "updateQueryAnswer",
      "updateShowError",
      "updateErrorMsg",
      "updateReloadPage"
    ]),
    async getAddressInfo() {
      let errorMsg = "Connection failed!Please check Internet connection.";
      try {
        if (!this.checkAddress(this.address)) {
          throw new Error("Error: Invalid Address");
        }
      } catch (e) {
        errorMsg = "Invalid  address. Please check the precision of address.";
        this.updateShowError(true);
        this.updateErrorMsg(errorMsg);
        return;
      }
      try {
        const res = await this.$http.get(
          `${this.$config.apiEndPoint}/token/${this.tokenId}/address/${this.address}`
        );
        if (res && res.data && res.data.result) {
          this.updateQueryAnswer(res.data.result);
        } else {
          errorMsg =
            res && res.data && !res.data.result
              ? "This address did not involve in activity of the token."
              : errorMsg;
          throw new Error("Error: Cannot get data from remote.");
        }
      } catch (e) {
        if (e.response && e.response.status && e.response.status === 404) {
          this.updateQueryAnswer({});
          return;
        } else if (e.code === "ECONNABORTED") {
          errorMsg =
            "Time out! Please check Internet connection or try again later.";
        }
        this.updateShowError(true);
        this.updateErrorMsg(errorMsg);
      }
    },
    searchByType(type) {
      //v-input__icon // .v-input
      this.type = type;
      this.$refs.txTable.searchByType(type);
    },
    menuItemFontColor(item) {
      return this.type === item
        ? "primary--text text-capitalize"
        : "text-capitalize";
    },
    checkAddress(address) {
      const ADDRESS_VERSION = 5;
      if (!address || typeof address !== "string") {
        throw new Error("Missing or invalid address");
      }
      let address_bytes = Base58.decode(address);
      if (
        address_bytes[0] !== ADDRESS_VERSION ||
        address_bytes[1] !== this.network_byte
      ) {
        return false;
      }
      let key = address_bytes.slice(0, 22);
      let check = address_bytes.slice(22, 26);
      let key_hash = this.hash(key).slice(0, 4);
      for (let i = 0; i < 4; i++) {
        if (check[i] !== key_hash[i]) {
          return false;
        }
      }
      return true;
    },
    async listenExpandTable(val) {
      if (!val) {
        return;
      }
      if (val.goal === "UpdateExpandTable" && val.data && val.data.address) {
        this.txParams = { tokenId: this.tokenId, address: val.data.address };
        this.address = val.data.address;
        await this.getAddressInfo();
        this.updateReloadPage(false);
      }
    },
    hash(input) {
      return this.hashChain(input);
    },
    hashChain(input) {
      return this.keccak(this.blake2b(input));
    },
    keccak(input) {
      return Sha3.keccak256.array(input);
    },
    blake2b(input) {
      let output = new Uint8Array(32);
      Blake2b(output.length)
        .update(input)
        .digest(output);
      return output;
    }
  }
};
</script>
<style>
@font-face {
  /* font-properties */
  font-family: sfDisplaySemFont;
  src: url("../../assets/font/SF-Pro-Display-Semibold.otf");
}
</style>
